import { useHorizontalScrollSynchronization } from './use-horizontal-scroll-synchronization.hook';

/**
 * Keeps the time scale (scroll/zoom) in sync across charts that belong
 * to the same timeframe group (main candlestick + subplots). No global
 * broadcast between different timeframe tabs.
 */
export const useChartGroupTimeScaleSync = () => {
  // Reuse the generic sync hook with listeners enabled; `syncOnRangeChange`
  // wires visible-range listeners so any user-driven scroll/zoom on one chart
  // immediately mirrors to its siblings within this timeframe only.
  return useHorizontalScrollSynchronization({ syncOnRangeChange: true });
};
